// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"502":"ucare-panel-chunk","868":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"502":"a5e5987c","609":"04ea7e96","868":"6a8cddef"}[chunkId] + ".chunk.js";
};